import BasicResource from '@/api/resource';

class Resource extends BasicResource {
    constructor () {
        super('user-profile');
    }

    update (data) {
        return this.client.request({
            method: 'put',
            path: `/publisher/v1/${this.resourceName}`,
            data: data,
        });
    }

    updateBillingDetails (data) {
        return this.client.request({
            method: 'put',
            path: `/publisher/v1/${this.resourceName}/billing`,
            data: data,
        });
    }

    acceptTCs (data) {
        return this.client.request({
            method: 'put',
            path: `/publisher/v1/${this.resourceName}/tos-accept`,
            data,
        });
    }
}

export default new Resource;
